import React from 'react';

interface GlyphType {
  size?: 16 | 24 | 32;
  color?: string;
  children?: React.ReactSVGElement;
}

const Index = ({ size = 16, color = 'currentColor', ...rest }: GlyphType): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32" {...rest}>
      {rest.children}
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M9.99198046,23.962796 L5.04223299,19.0130486 C4.06592226,18.0367378 4.06592226,16.4538254 5.04223299,15.4775147 C6.01854372,14.5012039 7.60145617,14.5012039 8.5777669,15.4775147 L11.7597474,18.6594952 L23.4270093,6.99223328 C24.40332,6.01592255 25.9862325,6.01592255 26.9625432,6.99223328 C27.9388539,7.96854401 27.9388539,9.55145645 26.9625432,10.5277672 L13.5275144,23.962796 C12.5512036,24.9391068 10.9682912,24.9391068 9.99198046,23.962796 Z"
        />
      </g>
    </svg>
  );
};

export default Index;
